var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCenterArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 769,
    height: 645,
    viewBox: "0 0 769 645",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 532.752,
    y: 399.25,
    width: 3.5,
    height: 4.5,
    transform: "rotate(-90 532.752 399.25)",
    stroke: "#D94F56",
    strokeWidth: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 532.752,
    y: 521.25,
    width: 3.5,
    height: 4.5,
    transform: "rotate(-90 532.752 521.25)",
    stroke: "#D94F56",
    strokeWidth: 3.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 532.752,
    y: 603.25,
    width: 3.5,
    height: 4.5,
    transform: "rotate(-90 532.752 603.25)",
    stroke: "#D94F56",
    strokeWidth: 3.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 532.752,
    y: 479.25,
    width: 3.5,
    height: 4.5,
    transform: "rotate(-90 532.752 479.25)",
    stroke: "#D94F56",
    strokeWidth: 3.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1.75,
    y: -1.75,
    width: 3.5,
    height: 4.5,
    transform: "matrix(0 -1 -1 0 234.5 641.5)",
    stroke: "#4E5055",
    strokeWidth: 3.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -1.75,
    y: -1.75,
    width: 3.5,
    height: 4.5,
    transform: "matrix(0 -1 -1 0 234.5 559.5)",
    stroke: "#D7544F",
    strokeWidth: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M492 398L534 398",
    stroke: "#D94F56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M459 520L534 520",
    stroke: "#D94F56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M459 602L534 602",
    stroke: "#D94F56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M492 478L534 478",
    stroke: "#D94F56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M248 642H235",
    stroke: "#4E5055"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M248 560H238",
    stroke: "#D7544F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M536.502 397.5L594.002 397.5C610.57 397.5 624.001 384.069 624.001 367.5V31C624.001 14.4314 637.433 1 654.001 1H768.002",
    stroke: "#D94F56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M537 520L594 520C610.569 520 624 506.568 624 490V325",
    stroke: "#D94F56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M537 602L594 602C610.569 602 624 588.568 624 572V325",
    stroke: "#D94F56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M537 478L594 478C610.569 478 624 464.568 624 448V325",
    stroke: "#D94F56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M233 642L175 642C158.431 642 145 628.568 145 612V31C145 14.4314 158.431 1 175 1H176.177",
    stroke: "#4E5055"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232 560L154.732 560C138.163 560 124.732 546.568 124.732 530V32C124.732 15.4314 111.3 2 94.7317 2H-3.21262e-06",
    stroke: "#D7544F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterArrows);
export default __webpack_public_path__ + "static/media/center-arrows.2613cd90f76b7e2b719bcd168ff342bf.svg";
export { ForwardRef as ReactComponent };